import React from "react";
import CollapsableSettingsCard from "components/newSettings/Settings.collapsable";
import translate from "components/translations/translations.wrapper";
import NotificationsContent from "components/newSettings/Settings.notifications.content";
import PreferencesContent from "components/newSettings/Settings.preferences.content";
import SubstituteContent from "components/newSettings/Settings.substitute.content";
import {useSelector} from "react-redux";
import * as reduxSelectors from "components/store/application.reducers";
import "components/newSettings/newSettings.scss";

export const NewSettingsMainPage = ({...props}: any): React.ReactElement => {

    const userRoles= useSelector(reduxSelectors.getUsersRoles);

    return <main className="page w-100 overflow-y-auto d-flex justify-content-center align-items-start">
        <div className={"py-16 w-50 mt-24 settings-page__container"}>
            <h2 className={"ps-4"}>{props.translate("settings.approvalSettings")}</h2>
            {[
                {
                    title: props.translate("settings.approverNotifications"),
                    subtitle: props.translate("settings.notificationsMoreInfo"),
                    content: <NotificationsContent/>,
                    isAvailable:userRoles?.manageMySettingsRightsToView
                },
                {
                    title: props.translate("settings.substitutes"),
                    subtitle: props.translate("settings.substitutesMoreInfo"),
                    content: <SubstituteContent/>,
                    isAvailable:userRoles?.mySubstituteRightsToView
                },
                {
                    title: props.translate("settings.otherSettings"),
                    subtitle: props.translate("settings.preferencesMoreInfo"),
                    content: <PreferencesContent {...props} />,
                    isAvailable: userRoles?.preferencesRightsToView
                }
            ].map((section, index) => (
                <div key={`${section.title}-${index}`} className="mb-4">
                    {section.isAvailable &&
                        <CollapsableSettingsCard {...section} />
                    }
                </div>
            ))}
        </div>
    </main>
}

const withTranslations = translate(NewSettingsMainPage);
export default withTranslations;
